import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import {polyglot} from '../../../../index'
import { TabsContainer } from '../../../common/TabsContainer/TabsContainer'
import { Panel } from '../../../common/Panel/Panel'
import { Button } from '../../../common/Button/Button'
import { CustomTooltip } from '../../../common/CustomTooltip/CustomTooltip'
import { ReactModal } from '../../../common/ReactModal/ReactModal'
import moment from 'moment/moment'
import { Field } from '../../../common/Field/Field'

import './style.css'
import update from 'react-addons-update'

const dateFormat = {
  standartData: 'YYYY-MM-DD'
}

export default class Medication extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      elements: {},
      modalIsOpen: false,
      panelStatus: undefined,
      clickedElement: undefined,
      clickedElementKey: undefined,
      deleteClicked: false
    }
    this.toggleModal = this.toggleModal.bind(this)
    this.updateState = this.updateState.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }
  componentWillMount () {
    let status = 'panel-default'
    if (this.props.medication && Object.keys(this.props.medication).length > 0) {
      status = 'panel-info'
    }
    this.setState({
      panelStatus: status
    })
  }
  componentWillReceiveProps (props) {
    let status = 'panel-default'
    if (props.medication && Object.keys(props.medication).length > 0) {
      status = 'panel-info'
    }
    this.setState({
      panelStatus: status
    })
  }

  toggleModal () {
    this.setState({
      modalIsOpen: !this.state.modalIsOpen
    })
  }

  getCurrentMedication (medicationArray) {
    const usual = this.getUsualMedication(medicationArray)
    const temporary = this.getTemporaryMedication(medicationArray)
    return {...usual, ...temporary}
  }

  getUsualMedication (medicationArray) {
    const result = {}
    Object.keys(medicationArray).forEach(key => {
      if (medicationArray[key].status === 'usual') {
        result[key] = medicationArray[key]
      }
    })
    return result
  }

  getTemporaryMedication (medicationArray) {
    const result = {}
    Object.keys(medicationArray).forEach(key => {
      if (medicationArray[key].status === 'temporary') {
        result[key] = medicationArray[key]
      }
    })
    return result
  }

  getPastMedication (medicationArray) {
    const result = {}
    Object.keys(medicationArray).forEach(key => {
      if (medicationArray[key].status === 'finished') {
        result[key] = medicationArray[key]
      }
    })
    return result
  }
  renderMedication (medicationArray) {
    return <ul className='medication-list'>
      {Object.keys(medicationArray).map((key) => {
        const medication = medicationArray[key]
        return <li onClick={() => { this.openModalForEdit(key) }} key={key}>
          <CustomTooltip tooltipPosition={'top'} toolTipText={medication.doctor} toolTipTitle={medication.date}>
            <div><span>{medication.type}</span></div>
          </CustomTooltip>
        </li>
      })
      }
    </ul>
  }

  openModalForEdit (key) {
    const data = this.props.medication[key]
    const _data = data && data !== null ? data : {}
    this.setState({
      elements: _data,
      clickedElement: data || null,
      clickedElementKey: key
    })
    this.toggleModal()
  }

  getSavedDataForElement (key) {
    if (this.state.clickedElement) {
      return this.state.clickedElement[key]
    }
  }

  renderDeleteButton () {
    if (this.state.clickedElement) {
      return <Fragment>
        {this.state.deleteClicked
          ? <Button
            onClick={() => { this.deleteEntry(this.state.clickedElementKey) }}
            text={polyglot.t('staticFields.commonFields.confirmDelete')}
            buttonType={'btn btn-info'}
            type={'button'} />
          : null
        }
        <Button
          onClick={() => { this.setState({deleteClicked: true}) }}
          text={polyglot.t('staticFields.commonFields.delete')}
          buttonType={'btn btn-danger'}
          type={'button'} />
      </Fragment>
    }
  }

  deleteEntry (key) {
    this.props.handleMedicationChange(key, null)
    this.toggleModal()
    this.clearClickedElement()
  }

  handleSubmit (e) {
    e.preventDefault()
    this.toggleModal()
    const result = this.state.elements
    result['doctor'] = this.props.doctorName
    if (this.state.clickedElementKey) {
      this.props.handleMedicationChange(this.state.clickedElementKey, this.state.elements)
    } else {
      this.props.handleMedicationSubmit(this.state.elements)
    }
    this.clearClickedElement()
  }

  clearClickedElement () {
    this.setState({
      clickedElement: undefined,
      clickedElementKey: undefined,
      deleteClicked: false,
      elements: {}
    })
  }

  updateState (name, value) {
    let updated
    if (value === '') {
      updated = update(this.state.elements, {
        [name]: {$set: null}
      })
    } else {
      updated = update(this.state.elements, {
        [name]: {$set: value}
      })
    }
    this.setState({
      elements: updated
    })
  }

  getContentForContainer () {
    if (this.props.medication) {
      return [{
        label: polyglot.t('staticFields.home.medication.usual'),
        content: this.renderMedication(this.getCurrentMedication(this.props.medication))
      }, {
        label: polyglot.t('staticFields.home.medication.past'),
        content: this.renderMedication(this.getPastMedication(this.props.medication))
      }]
    }
  }

  render () {
    return <Fragment>
      <Panel
        footer={<div className='clearfix'>
          <div className='pull-right'>
            <Button text={polyglot.t('staticFields.home.medication.addMedication')} buttonType={'btn btn-primary'} type={'button'} onClick={this.toggleModal} />
          </div>
        </div>}
        heading={polyglot.t('staticFields.home.medication.title')}
        panelType={this.state.panelStatus}>
        <TabsContainer content={this.getContentForContainer()} emptyMessage={polyglot.t('staticFields.home.medication.noMedication')} />
      </Panel>
      <ReactModal
        footer={this.renderDeleteButton()}
        name={polyglot.t('staticFields.home.medication.title')}
        toggleModal={this.toggleModal}
        modalIsOpen={this.state.modalIsOpen}>
        <div className='form-horizontal'>
          <form onSubmit={e => this.handleSubmit(e)}>
            {this.props.config.elements.map(element => {
              return <Field
                savedData={this.getSavedDataForElement(element.name)}
                getValue={this.updateState}
                minDateForCalendar={this.props.minDateForCalendar}
                maxDateForCalendar={moment().format(dateFormat.standartData)}
                required={!element.optional}
                key={element.label}
                label={element.label}
                elements={element.elements}
                name={element.name}
                type={element.type} />
            })}
            <Button type='submit' text={polyglot.t('staticFields.commonFields.save')} buttonType='btn-primary btn-block' />
          </form>
        </div>
      </ReactModal>
    </Fragment>
  }
}

Medication.propTypes = {
  medication: PropTypes.object,
  handleMedicationSubmit: PropTypes.func.isRequired,
  handleMedicationChange: PropTypes.func.isRequired,
  config: PropTypes.object.isRequired,
  doctorName: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/general/Home/Medication/Medication.js